import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';

import { actions } from '../redux';

const useActiveUsersStatistics = (form, enabled, withTimeseries) => {
  const dispatch = useDispatch();
  const selectedAgentId = useSelector(state => state.tree.selectedAgentId);
  const statistic = useSelector(state => state.reports.activeUsersStatistic);
  const lastRequest = useRef('');
  const lastTimeseriesRequest = useRef('');
  const requestKey = JSON.stringify([
    selectedAgentId,
    dayjs(form.date.beginDate).format('YYYY-MM-DD'),
    dayjs(form.date.endDate).format('YYYY-MM-DD'),
    form.structure.value,
    form.withDiff,
    form.withDiff && dayjs(form.diffDate.compareFrom).format('YYYY-MM-DD'),
    form.withDiff && dayjs(form.diffDate.compareTo).format('YYYY-MM-DD'),
  ]);
  const timeseriesKey = JSON.stringify([
    requestKey,
    dayjs(form.diffDate.compareFrom).format('YYYY-MM-DD'),
    dayjs(form.diffDate.compareTo).format('YYYY-MM-DD'),
  ]);

  useEffect(() => {
    if (!enabled) {
      lastRequest.current = '';
      lastTimeseriesRequest.current = '';
      return;
    }
    if (!selectedAgentId || statistic.isLoading) return;

    // Keep only the latest filters while a full-statistics request is in flight.
    if (lastRequest.current !== requestKey) {
      lastRequest.current = requestKey;
      dispatch(actions.getStatisticProvider({ ...form, isFullStatistic: true, requestKey }));
      return;
    }
    if (withTimeseries && lastTimeseriesRequest.current !== timeseriesKey) {
      lastTimeseriesRequest.current = timeseriesKey;
      dispatch(actions.getReportTimeseries({ ...form, metric: 'active_users', requestKey: timeseriesKey }));
    }
  }, [dispatch, enabled, form, requestKey, selectedAgentId, statistic.isLoading, timeseriesKey, withTimeseries]);

  return {
    isLoading: statistic.isLoading || Boolean(enabled && selectedAgentId && lastRequest.current !== requestKey),
    data: enabled && statistic.requestKey === requestKey ? statistic.data : null,
    timeseries: withTimeseries && statistic.timeseriesKey === timeseriesKey ? statistic.timeseries : null,
    reload: () => {
      lastRequest.current = '';
    },
  };
};

export default useActiveUsersStatistics;
